/* Figma annotation: reveal timeline entries once. Content remains visible
 * without JavaScript and when reduced motion is requested. No scroll trap. */
(() => {
  function initialize(root = document) {
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const entries = root.querySelectorAll('[data-about-entry]:not([data-about-ready])');
    const observer = new IntersectionObserver((changes) => {
      changes.forEach(({ target, isIntersecting }) => {
        if (!isIntersecting) return;
        target.classList.remove('is-about-pending');
        target.classList.add('is-about-revealed');
        observer.unobserve(target);
      });
    }, { threshold: 0.08 });
    entries.forEach((entry) => {
      entry.dataset.aboutReady = 'true';
      if (entry.getBoundingClientRect().top > window.innerHeight) entry.classList.add('is-about-pending');
      observer.observe(entry);
    });
  }
  initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
